/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setQryStrMedium,
  setQryStrSource,
  setQryStrMode,
  setQryStrDevice,
  setQryStrTCPAddr,
  setQryStrTCPPort,
} from "./SelfServiceTools/redux/queryStrings/queryStringsActions";
import { useSelector } from "react-redux";
import "./App.scss";

// import LangSwitcher from "./SelfServiceTools/Components/LangSwitcher";
import Constants from "./SelfServiceTools/Constants";
import HomeContainer from "./SelfServiceTools/screens/HomeContainer";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    const queryString = window.location.search;
    const parameters = new URLSearchParams(queryString);
    const medium = parameters.get("utm_medium");
    const source = parameters.get("utm_source");
    const mode = parameters.get("mode");
    const device = parameters.get("device");
    const TcpMwAddr = parameters.get("tcp_mw_addr");
    const TcpMwPort = parameters.get("tcp_mw_port");
    dispatch(setQryStrMedium(medium));
    dispatch(setQryStrSource(source));
    dispatch(setQryStrMode(mode));
    dispatch(setQryStrDevice(device));
    dispatch(setQryStrTCPAddr(TcpMwAddr));
    dispatch(setQryStrTCPPort(TcpMwPort));
  }, []);

  const { medium, source, mode } = useSelector((state) => state.queryStrings);

  return (
    <>
      {/* <LangSwitcher /> */}
      {/* <RegistrationContainer
        medium={medium}
        source={source}
        locale={Constants.OM.enlocaleCode}
      /> */}
      <HomeContainer
        medium={medium}
        source={source}
        mode={mode}
        locale={Constants.AE.enlocaleCode}
      />
    </>
  );
}

export default App;
